
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.41 7.41L14.58 2.58C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.41ZM15.74 18.74C15.35 19.13 14.72 19.13 14.33 18.74L13.15 17.56C11.82 18.27 10.14 18.09 9.02 16.97C7.5 15.45 7.67 12.89 9.52 11.6C10.68 10.79 12.3 10.79 13.47 11.6C15.02 12.68 15.37 14.64 14.56 16.15L15.74 17.33C16.13 17.72 16.13 18.35 15.74 18.74ZM14 9C13.45 9 13 8.55 13 8V3.5L18.5 9H14Z' fill='#323232'/><path d='M11.5 16C12.3284 16 13 15.3284 13 14.5C13 13.6716 12.3284 13 11.5 13C10.6716 13 10 13.6716 10 14.5C10 15.3284 10.6716 16 11.5 16Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-plagiarism`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPlagiarism

    ```js
    <b-new-b-icon-plagiarism />
    ```
</docs>


